import { Plus24Px } from "@locaisolutions/icons";
import { Card, Typography, Button } from "@mui/material";
import { Box } from "@mui/system";

import { PropsWithChildren } from "react";

export const DistributionProfileFields = ({
  onAdd,
  label,
  avg,
  children
}: {
  onAdd: () => void;
  avg: number;
  label: string;
} & PropsWithChildren) => {
  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        p: 2,
        flexBasis: 250
      }}
    >
      <Box>
        <Typography variant="h6">{label}</Typography>
        <Button
          variant="subtle"
          startIcon={<Plus24Px fill="currentColor" />}
          aria-label={`Add ${label}`}
          onClick={onAdd}
        >
          Add
        </Button>
        {children}
      </Box>
      <Typography variant="body2" sx={{ textAlign: "end" }}>
        Average: {avg.toFixed(2)}
      </Typography>
    </Card>
  );
};
